import "./index.css";
import { lazy, Suspense } from "react";
import { BrowserRouter as Router, useRoutes } from "react-router-dom";
import { Spinner } from "./components";
import { USER_ID } from "./session";
import { BRANCH_RELEASE } from "./consts";

const TrackShipments = lazy(() => import("./pages/track-shipments"));
const Tracking = lazy(() => import("./pages/tracking"));
const NotFound = lazy(() => import("./pages/not-found"));
const Login = lazy(() => import("./pages/login"));
const HomeSession = lazy(() => import("./pages/home-session"));
const RequestAQuote = lazy(() => import("./pages/request-a-quote"));

function App() {
  const element = useRoutes([
    {
      path: "/",
      element: (
        <RouteSuspense element={USER_ID ? <HomeSession /> : <Login />} />
      ),
    },
    {
      path: "track-a-shipment",
      element: <RouteSuspense element={<TrackShipments />} />,
    },
    {
      path: "tracking/:tracking",
      element: <RouteSuspense element={<Tracking />} />,
    },
    {
      path: "request-a-quote",
      element: <RouteSuspense element={<RequestAQuote />} />,
    },
    { path: "*", element: <RouteSuspense element={<NotFound />} /> },
  ]);

  return element;
}

const RouteSuspense = ({ element }: { element: React.ReactNode }) => (
  <Suspense fallback={<Spinner />}>{<>{element}</>}</Suspense>
);

const AppWrapper = () => {
  return (
    <Router basename={BRANCH_RELEASE ? "/session" : "/"}>
      <App />
    </Router>
  );
};

export default AppWrapper;
